module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Bateria RO.e90e71fb.png";